<template>
  <div class="productInquiry">
    <product-inquiry-type-tab ref="inquiryTypeTab" @sumitBox="sumitBox" @tabCheckType="tabCheckType" :nowShowType="nowShowType"></product-inquiry-type-tab>
    <div class="sd_hotel_mod cleanFloat" v-if="nowShowType=='hotel'||nowShowType=='site'">
      <div class="hotel_mod_left">
        <div v-if="nowShowType=='hotel'">
          <div>
            <div class="mod_li" v-for="(item,index) in hotelData" :key="index" :class="index == hotelChangeIndex?'checkedLi':''" 
              @click="checkOneData(index)">
              <span class="xuhao">{{index+1}}</span>
              <b>&nbsp;入住及离店日期：&nbsp;</b>
              <el-date-picker v-model="item.checkDate" value-format="yyyy-MM-dd" size="mini" :unlink-panels="true" :clearable="false"
                :editable="false" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" @change="changeDate(item)">
              </el-date-picker>
              <label>&nbsp;&nbsp;{{getBetweenDay(item.checkDate)}}晚</label>
              <city-autocomplete :obj="item"></city-autocomplete>
              <i class="el-icon-delete" @click.stop="delOneData(index,hotelData,1)" v-if="hotelData.length>1"></i>
            </div>
          </div>
          <div class="infor_input">
            <ul>
              <li class="date_city_li">
                <span>{{hotelData[hotelChangeIndex].startDate}}&nbsp;&nbsp;至&nbsp;&nbsp;{{hotelData[hotelChangeIndex].endDate}}</span>
                <span>{{getBetweenDay(hotelData[hotelChangeIndex].checkDate)}}晚</span>
                <span v-if="hotelData[hotelChangeIndex].cityId">{{hotelData[hotelChangeIndex].cityName}}</span>
              </li>
            </ul>
            <hotel-product-inquiry :hotelData="hotelData[hotelChangeIndex]"></hotel-product-inquiry>
          </div>
          <div class="input_infor_show" @click="addOneData">增加其他入住日期</div>
        </div>
        <div v-else>
          <ul id="siteProjectInquiry">
            <li v-for="(item,index) in siteData" :key="index" :class="index == siteChangeIndex?'checkedLi':''"
              @click="checkOneData(index)">
              <div class="site_div_one">
                <b>亲，您需要在哪个城市举办这次会议/活动？</b>
                <city-autocomplete :obj="item" :width="'width: 1.8rem;margin-left: 0.1rem;'"></city-autocomplete>
              </div>
              <div class="site_div_two">
                <span class="xuhao" style="margin-right: 0.05rem;">{{index+1}}</span>
                <b>举办时间？</b>
                <p style="margin-left: 0.2rem;">
                  <el-radio v-model="item.dateType" :label="1">有相对准确的日期</el-radio>
                  <el-radio v-model="item.dateType" :label="2">有大致日期范围</el-radio>
                </p>
                <i class="el-icon-delete" @click.stop="delOneData(index,siteData,1)" v-if="siteData.length>1"></i>
              </div>
              <div class="site_div_three">
                <p>
                  <span v-show="item.dateType ===1">
                    <el-date-picker v-model="item.useDate" type="date" :unlink-panels="true" :clearable="false" :editable="false"
                      size="mini" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 1.9rem;margin-right: 0.15rem;">
                    </el-date-picker>
                  </span>
                  <span v-show="item.dateType === 2">
                    <el-select v-model="item.useYear" placeholder="请选择年" size="mini" style="width: 1.9rem;margin-right: 0.15rem;">
                      <el-option v-for="i in yearOption" :key="i+'年'" :label="i+'年'" :value="i"></el-option>
                    </el-select>
                    <el-select v-model="item.useMonth" placeholder="请选择月"  size="mini" style="width: 1.9rem;margin-right: 0.15rem;">
                      <el-option v-for="i in 12" :key="i+'月'" :label="i+'月'" :value="i"></el-option>
                    </el-select>
                  </span>
                  <span>
                    <el-select v-model="item.useDay" placeholder="请选择天数" style='width:1.9rem' size="mini">
                      <el-option v-for="text in durationOption" :key="text" :label="text" :value="text"></el-option>
                    </el-select>
                  </span>
                </p>
              </div>
            </li>
          </ul>
          <div class="site_infor">
            <site-product-inquiry :siteData="siteData[siteChangeIndex]"></site-product-inquiry>
          </div>
          <div class="input_infor_show" @click="addOneData">增加其他会议日期</div>
        </div>
      </div>
      <div class="hotel_mod_right">
        <ul v-if="nowShowType=='hotel'">
          <li v-for="(item,index) in hotelData" :key="index">
            <div class="hmr_left">
              <b>{{index+1}}</b>
              <p>
                <i></i>
                <span class="el-icon-caret-right"></span>
              </p>
            </div>
            <div class="hmr_right">
              <p><span v-if="item.checkDate.length>0">
                {{item.checkDate[0]}}&nbsp;&nbsp;至&nbsp;&nbsp;{{item.checkDate[1]}}&nbsp;&nbsp;
                {{getBetweenDay(item.checkDate)}}晚&nbsp;&nbsp;<span v-if="item.cityId">{{item.cityName}}</span></span>
              </p>
              <hotel-product-inquiry-show :hotelData="item"></hotel-product-inquiry-show>
            </div>
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item,index) in siteData" :key="index">
            <div class="hmr_left">
              <i class="left_line" v-show="index!=0"></i>
              <b>{{index+1}}</b>
              <p>
                <i></i>
                <span class="el-icon-caret-right"></span>
              </p>
            </div>
            <div class="hmr_right">
              <template v-if="item.dateType==1">
                <span v-show="item.useDate!=''||item.useDay!=''">
                  {{item.useDate}}<i>/</i>
                </span>
              </template>
              <template v-if="item.dateType==2">
                <span v-show="item.useYear!=''||item.useDay!=''">
                  {{item.useYear}}-{{item.useMonth}}<i>/</i>
                </span>
              </template>
              <site-product-inquiry-show :item="item"></site-product-inquiry-show>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bus_outSide_box" v-else>
      <div class="bus_mod_box" v-if="nowShowType=='spot'">
        <people-box :spotData="spotData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>景点</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(spotItem,index) in spotData.spotProductInquiryList" :key="index" class="li">
                <b class="needText" v-if="index==0">亲,您需要</b>
                <div class="special" v-if="index!=0">
                  <i class="andOr" v-show="spotItem.addType!=''">{{spotItem.addType}}</i>
                </div>
                <span style="margin-right: 0.05rem;">
                  <el-date-picker v-model="spotItem.useDate" type="date" :unlink-panels="true" :clearable="false"
                    :editable="false" size="mini" style='width: 1.5rem;' value-format="yyyy-MM-dd" placeholder="请选择日期">
                  </el-date-picker>
                </span>
                <span style="margin-right: 0.05rem;">
                  <city-autocomplete :obj="spotItem" :width="'width: 1.3rem;'"></city-autocomplete>
                </span>
                <span style="margin-right: 0.1rem;">
                  <spot-autocomplete :spotItem="spotItem"></spot-autocomplete>
                </span>
                <span>
                  <el-radio-group v-model="spotItem.spotType">
                    <el-radio label="散客票">散客票</el-radio>
                    <el-radio label="团队票">团队票</el-radio>
                    <el-radio label="专业讲解">专业讲解</el-radio>
                  </el-radio-group>
                </span>
                <operation-button :addObj="spotProductInquiryList" :arr="spotData.spotProductInquiryList" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.85rem;">
              <el-input v-model="spotData.remarks" placeholder="请在此处填写其他您想告知我们的需求，我们将尽快为您提供您需要的专属特价"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="spotData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='traffic'">
        <people-box :spotData="trafficData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>车型</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in trafficData.trafficProductInquiries" :key="index" class="li">
                <b class="needText" style="width: 1.83rem;" v-if="index==0">亲，您需要的车型是？</b>
                <div class="special" style="width: 1.83rem;" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <traffic-product-inquiry :carItem="carItem"></traffic-product-inquiry>
                <operation-button :arr="trafficData.trafficProductInquiries" :addObj="trafficProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 1.83rem;">
              <el-input v-model="trafficData.remarks" placeholder="如果您需要的不是上面的车型，请填写您需要什么样的车？和其他备注说明"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="trafficData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='communication'">
        <people-box :spotData="communicationData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>交通</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in communicationData.bigTrafficProductInquiries" :key="index" class="li">
                <b class="needText"  v-if="index==0">亲,您需要</b>
                <div class="special" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <span class="selectSpan">
                  <el-select v-model="carItem.trafficType" placeholder="请选择" style='width:1rem' size="mini">
                    <el-option v-for="(text,i) in communicationOptionOne" :key="i" :label="text" :value="text"></el-option>
                  </el-select>
                </span>
                <span class="selectSpan">
                  <city-autocomplete :obj="carItem" :width="'width: 1.4rem;'"></city-autocomplete>
                </span>
                <span class="selectSpan">
                  <city-autocomplete :obj="carItem" :width="'width: 1.4rem;'" :nameProName="'endCityName'" :idProName="'endCityId'"></city-autocomplete>
                </span>
                <span>
                  <el-date-picker v-model="carItem.useDate" type="date" :unlink-panels="true" :clearable="false" :editable="false"
                    size="mini" style='width:1.4rem' value-format="yyyy-MM-dd" placeholder="出发日期">
                  </el-date-picker>
                </span>
                <span class="selectSpan">
                  <el-input v-model="carItem.expectFlight" placeholder="期望的班(船)/次或时间" size="mini" style="width: 2.1rem;"></el-input>
                </span>
                <operation-button :arr="communicationData.bigTrafficProductInquiries" :addObj="bigTrafficProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.85rem;">
              <el-input v-model="communicationData.remarks" placeholder="亲，正常会都按照经济舱报价，如有特殊舱位需求、或其他特殊需求等（如VIP通道等），请在此备注，我们将会按照要求，为您安排合适的产品"
                size="mini"></el-input>
            </p>
          </div>
        </div>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='restaurant'">
        <people-box :spotData="restaurantData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>餐食</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in restaurantData.mealProductInquiries" :key="index" class="li">
                <b class="needText" style="width:0.98rem" v-if="index==0">亲，您需要</b>
                <div class="special" style="width:0.98rem" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <span class="selectSpan">
                  <city-autocomplete :obj="carItem" :width="'width: 1.5rem;'"></city-autocomplete>
                </span>
                <span class="selectSpan">
                  <el-input v-model="carItem.number" placeholder="请填写" style="width:0.77rem" size="mini"
                    @input="carItem.number=carItem.number.replace(/[^\d]/g,'')"></el-input>
                </span>
                <b style="margin-right: 0.05rem;">顿</b>
                <span class="selectSpan">
                  <el-select v-model="carItem.mealType" placeholder="请选择" style='width:1rem' size="mini">
                    <el-option v-for="(text,i) in restaurantOptionOne" :key="i" :label="text" :value="text"></el-option>
                  </el-select>
                </span>
                <span class="selectSpan" v-if="carItem.mealType&&carItem.mealType!=''">
                  <el-input v-model="carItem.meal" placeholder="菜品名称" style="width:1rem" size="mini"></el-input>
                </span>
                <span class="selectSpan">
                  <el-input v-model="carItem.budgetPrice" placeholder="预算（如有）" style="width:1rem" size="mini"></el-input>
                </span>
                <span class="selectSpan">
                  <currency-autocomplete :obj="carItem" :sizeType="'small'" :styleStr="'width:1rem'"></currency-autocomplete>
                </span>
                <operation-button :arr="restaurantData.mealProductInquiries" :addObj="mealProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.99rem;">
              <el-input v-model="restaurantData.remarks" placeholder="如您需其他用餐类型,或您有指定想询价的餐厅,请在此填写具体需求(城市、用餐时间、餐厅名称等),我们将尽快为您提供您需要的专属特价"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="restaurantData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='guide'">
        <people-box :spotData="guideData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>导服</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in guideData.trafficProductInquiries" :key="index" class="li">
                <b class="needText" style="width:0.98rem" v-if="index==0">亲，您需要</b>
                <div class="special" style="width:0.98rem" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <span>
                  <el-input v-model="carItem.busNumber" placeholder="" style="width:1rem" size="mini"
                    @input="carItem.busNumber=carItem.busNumber.replace(/[^\d]/g,'')"></el-input>
                </span>
                <b style="margin-right: 0.05rem;">位</b>
                <span>
                  <el-radio-group v-model="carItem.trafficType">
                    <el-radio label="全陪兼地陪">全陪兼地陪</el-radio>
                    <el-radio label="地接导游">地接导游</el-radio>
                    <el-radio label="伴游">伴游</el-radio>
                    <el-radio label="专业讲解">专业讲解</el-radio>
                  </el-radio-group>
                </span>
                <span class="selectSpan" v-show="carItem.trafficType=='专业讲解'">
                  <el-input v-model="carItem.busType" placeholder="请填写需要专讲的景点" style="width:1.9rem" size="mini"></el-input>
                </span>
                <operation-button :arr="guideData.trafficProductInquiries" :addObj="trafficProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.99rem;">
              <el-input v-model="guideData.remarks" placeholder="如果您需要的不是上面的导游类型，请填写您需要什么样的导游？和其他备注说明"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="guideData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='visa'">
        <people-box :spotData="visaData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>签证</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in visaData.visaProductInquiries" :key="index" class="li">
                <b class="needText" style="width:0.3rem" v-if="index==0">亲</b>
                <div class="special" style="width: 0.4rem;margin-left: -0.1rem;" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <span>
                  <city-autocomplete :obj="carItem" :searchType="0" :idProName="'countryId'" :nameProName="'countryName'" :width="'width: 1.8rem;'"></city-autocomplete>
                </span>
                <b style="margin-right: 0.05rem;">您申请的是</b>
                <span>
                  <el-select v-model="carItem.visaType"  placeholder="请选择" style='width:120px' size="mini">
                    <el-option v-for="(text,i) in visaOptionOne" :key="i" :label="text" :value="text"></el-option>
                  </el-select>
                </span>
                <span>
                  <el-select v-model="carItem.visaContent" placeholder="请选择" style='width:120px' size="mini">
                    <el-option v-for="(text,i) in visaOptionTwo" :key="i" :label="text" :value="text"></el-option>
                  </el-select>
                </span>
                <operation-button :arr="visaData.visaProductInquiries" :addObj="visaProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.3rem;">
              <el-input v-model="visaData.remarks" placeholder="请在此处填写其他您想告知我们的需求，我们将尽快为您提供您需要的专属特价"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="visaData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='business'">
        <people-box :spotData="businessData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>商务</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in businessData.businessProductInquiries" :key="index" class="li" style="display:block">
                <div style="display: flex;align-items: center;">
                  <b class="needText" style="width: 1.4rem;" v-if="index==0">亲，您需要的是</b>
                  <div class="special" style="width: 1.4rem;" v-if="index!=0">
                    <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                  </div>
                  <el-radio v-model="carItem.businessType" label="商务拜访">商务拜访</el-radio>
                  <el-radio v-model="carItem.businessType" label="邀请函及商务联系">邀请函及商务联系</el-radio>
                </div>
                <p style="display: flex;align-items: center;margin-left: 1.38rem;" class="selectSpan">
                  <span style="margin-right: 0.05rem;">
                    <city-autocomplete :obj="carItem" :width="'width: 1rem;'"></city-autocomplete>
                  </span>
                  <el-input v-model="carItem.businessIndustry"
                    :placeholder="carItem.businessType=='商务拜访'?'您想拜访的行业':'您的对口行业'"
                    size="mini" style="width: 1.4rem;margin-right: 0.05rem;"></el-input>
                  <el-input v-model="carItem.time"
                    :placeholder="carItem.businessType=='商务拜访'?'拜访时间和拜访时长':'邀请时间和邀请时长'"
                    size="mini" style="width: 2.3rem;margin-right: 0.05rem;"></el-input>
                  <el-input v-model="carItem.objective"
                    placeholder="要求及拜访目的"
                    size="mini" style="width:2.1rem;margin-right: 0.05rem;"></el-input>
                  <operation-button :arr="businessData.businessProductInquiries" :addObj="businessProductInquiries" :index="index"></operation-button>
                </p>             
              </li>
            </ul>
            <p style="margin-left: 1.38rem;">
              <el-input v-model="businessData.remarks" placeholder="请在此处填写其他您想告知我们的需求，我们的商务专家将会尽快和您联系"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="businessData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='charact'">
        <people-box :spotData="charactData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>体验</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in charactData.chractProductInquiries" :key="index" class="li">
                <b class="needText" style="width: 1.35rem;" v-if="index==0">亲，您想在什么</b>
                <div class="special" style="width: 1.35rem;" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <span>
                  <city-autocomplete :obj="carItem" :width="'width:2rem'"></city-autocomplete>
                </span>
                <b style="margin-right: 0.2rem;">城市</b>
                <b style="margin-right: 0.05rem;">安排什么特色体验</b>
                <span>
                  <el-select v-model="carItem.content" placeholder="请选择" style='width:120px' size="mini" allow-create filterable>
                    <el-option v-for="(text,index1) in charactOptionOne" :key="index1" :label="text" :value="text"></el-option>
                  </el-select>
                </span>
                <operation-button :arr="charactData.chractProductInquiries" :addObj="chractProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.3rem;">
              <el-input v-model="charactData.remarks" placeholder="请在此处填写其他您想告知我们的需求，我们会尽快为您安排合适的产品"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="charactData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
      <div class="bus_mod_box" v-if="nowShowType=='service'">
        <people-box :spotData="serviceData"></people-box>
        <div class="car_type_box spot_type_box">
          <b>服务</b>
          <div style="margin: 0.2rem 0rem 0.2rem 0rem;width: 9.45rem;">
            <ul>
              <li v-for="(carItem,index) in serviceData.chractProductInquiries" :key="index" class="li">
                <b class="needText" style="width: 1.35rem;" v-if="index==0">亲，您想在什么</b>
                <div class="special" style="width: 1.35rem;" v-if="index!=0">
                  <i class="andOr" v-show="carItem.addType!=''">{{carItem.addType}}</i>
                </div>
                <span>
                  <city-autocomplete :obj="carItem" :width="'width:2rem'"></city-autocomplete>
                </span>
                <b style="margin-right: 0.2rem;">城市</b>
                <b style="margin-right: 0.05rem;">安排什么服务</b>
                <span>
                  <el-select v-model="carItem.content" placeholder="请选择" style='width:120px' size="mini">
                    <el-option v-for="(text,index1) in serviceOptionOne" :key="index1" :label="text" :value="text"></el-option>
                  </el-select>
                </span>
                <operation-button :arr="serviceData.chractProductInquiries" :addObj="chractProductInquiries" :index="index"></operation-button>
              </li>
            </ul>
            <p style="margin-left: 0.3rem;">
              <el-input v-model="serviceData.remarks" placeholder="如上述产品不符合您的需求，请在此处填写您的需求，我们会尽快为您安排合适的产品"
                size="mini"></el-input>
            </p>
          </div>
        </div>
        <router-box :spotData="serviceData" :yearOption="yearOption" :inquiryPlanObj="inquiryPlanObj"></router-box>
      </div>
    </div>
    <send-inquiry-dialog ref="sendInquiry" :identity="'供应商'"></send-inquiry-dialog>
  </div>
</template>

<script>
import sendInquiryDialog from './sendInquiryDialog.vue';
import PeopleBox from './peopleBox.vue';
import RouterBox from './routerBox.vue';
import CityAutocomplete from '../common/cityAutocomplete.vue';
import HotelProductInquiry from './child/hotelProductInquiry.vue';
import hotelProductInquiryShow from './child/hotelProductInquiryShow.vue';
import productInquiryTypeTab from './child/productInquiryTypeTab.vue';
import SiteProductInquiry from './child/siteProductInquiry.vue';
import SiteProductInquiryShow from './child/siteProductInquiryShow.vue';
import SpotAutocomplete from '../common/spotAutocomplete.vue';
import TrafficProductInquiry from './child/trafficProductInquiry.vue';
import OperationButton from './child/operationButton.vue';
import CurrencyAutocomplete from '../common/currencyAutocomplete.vue';
export default {
  components: { sendInquiryDialog, PeopleBox, RouterBox, CityAutocomplete, HotelProductInquiry,productInquiryTypeTab,hotelProductInquiryShow, 
  SiteProductInquiry,SiteProductInquiryShow,SpotAutocomplete,TrafficProductInquiry,OperationButton,CurrencyAutocomplete},
  data(){
    return{
      nowShowType: 'hotel',
      hotelData: [
        {
          startDate:'',
          endDate:'',
          checkDate: [],
          cityId: '',
          cityName:'',
          adult: 0,
          children: 0,
          star: '',
          location: '',
          breakfast: '',
          hotelRoomList: [{
            hotelRoomName: '',
            roomNumber: '',
            roomBudget: '',
            currency: '',
          }],
          remarks: '',
        }
      ],
      hotelChangeIndex:0,
      siteChangeIndex:0,
      siteData:[
        {
          cityId:null,
          cityName:null,
          dateType:1,
          useDate:null,
          useMonth:null,
          useYear:null,
          useDay:null,
          activeType:null,
          peopleType:1,
          peopleNumber:null,
          peopleNumRange:null,
          budgetPrice:null,
          currency:null,
          containServiceMap:{
            "场地":[],
            "人员":[],
            "设备":[],
            "策划":[],
            "宣传":[],
            "物料":[],
            "餐饮":[],
            "旅游":[],
          },
          remarks:null,
        }
      ],
      durationOption: ['1晚', '0.5天', '1天', '2天', '3-4天', '5-7天', '7-14天', '14天以上'],
      yearOption: [],
      spotData:{},
      spotProductInquiryList:{
        useDate:null,
        cityId:null,
        cityName:null,
        spotId:null,
        spotName:null,
        spotType:null,
        addType:null,
      },
      inquiryPlanObj:{
        dateRange:'',
        useDate:null,
        useMonth:null,//大致日期得月
        useDay:null,//使用天数
        cityObj:{
          cityId:null,
          cityName:null,
        },
        remark:null,
        endCityObj:{
          cityId:null,
          cityName:null,
        },
        otherCityObj:{
          cityId:null,
          cityName:null,
        },
        channelCities:[]
      },
      trafficData:{},
      trafficProductInquiries:{
        trafficType:null,
        busType:null,
        busNumber:null,
        addType:null,
      },
      communicationData:{},
      bigTrafficProductInquiries:{
        trafficType:null,
        useDate:null,
        cityId:null,
        cityName:null,
        endCityId:null,
        endCityName:null,
        expectFlight:null,
        addType:null,
      },
      communicationOptionOne: ['机票', '火车', '轮船'],
      restaurantData:{},
      mealProductInquiries:{
        cityId:null,
        cityName:null,
        number:null,
        mealType:null,
        meal:null,
        budgetPrice:null,
        currency:null,
        addType:null,
      },
      restaurantOptionOne: ['中餐', '西餐', '特色餐', '婚宴', '公司宴请'],
      guideData:{},
      visaData:{},
      visaProductInquiries:{
        countryId:null,
        countryName:null,
        visaType:null,
        visaContent:null,
        addType:null,
      },
      visaOptionOne: ['个人签证', '商务签证', '团队签证'],
      visaOptionTwo: ['旅游', '商务', '政府出行', '探亲访友', '留学', '务工'],
      businessData:{},
      businessProductInquiries:{
        cityId:null,
        cityName:null,
        businessType:null,
        businessIndustry:null,
        time:null,
        objective:null,
        addType:null,
      },
      charactData:{},
      chractProductInquiries:{
        cityId:null,
        cityName:null,
        content:null,
        addType:null,
      },
      charactOptionOne:[],
      serviceData:{},
      serviceOptionOne: ['机场VIP通道', '豪车接机', '礼仪接机'],
    }
  },
  methods:{
    sumitBox(){
      var hotelDataApi=[]
      var flag = true
      this.hotelData.forEach(e=>{
        if(!e.cityId){
          this.$message({type:"error",message:"请先选择城市"})
          flag = false
          return;
        }
        if(e.startDate&&e.endDate&&e.cityId&&e.cityName){
          hotelDataApi.push(e)
        }
      })
      var siteDataApi=[]
      this.siteData.forEach(e=>{
        if(e.cityId&&e.cityName&&e.dateType&&(e.useDate||e.useYear)){
          if(e.dateType==2){
            e.useDate = e.useYear
          }
          if(e.peopleType==2){
            e.peopleNumber = e.peopleNumRange
          }
          siteDataApi.push(e)
        }
      })
      var otherDataApi=[]
      this.$refs.inquiryTypeTab.navTabData.forEach(item=>{
        if(item.nameEn!='hotel'&&item.nameEn!='site'){
          var apiList = []
          this[item.nameEn + 'Data'][item.propName].forEach(e=>{
            if(item.nameEn=='spot'){
              if(e.cityId&&e.useDate&&e.spotId){
                apiList.push(e);
              }
            }else if(item.nameEn=='traffic'){
              if(e.trafficType&&e.busType){
                apiList.push(e);
              }
            }else if(item.nameEn=='communication'){
              if(e.useDate&&e.cityId&&e.endCityId){
                apiList.push(e);
              }
            }else if(item.nameEn=='guide'){
              if(e.trafficType){
                apiList.push(e);
              }
            }else if(item.nameEn=='visa'){
              if(e.countryId){
                apiList.push(e);
              }
            }else{
              if(e.cityId){
                apiList.push(e);
              }
            }
          })   
          if(apiList.length>0){
            if(this[item.nameEn + 'Data'].planType==1){
              this[item.nameEn + 'Data'].inquiryPlan.useDate = this[item.nameEn + 'Data'].inquiryPlan.dateRange[0]+"至"+this[item.nameEn + 'Data'].inquiryPlan.dateRange[1]
            }
            this[item.nameEn + 'Data'].resourceType = item.index;
            otherDataApi.push(this[item.nameEn + 'Data'])
          }
        }
      })
      var saveObj={
        hotelProjectInquiryList:hotelDataApi,
        siteProjectInquiries:siteDataApi,
        otherTypeProjectInquiries:otherDataApi,
      }
      if(flag){
        document.getElementById('projectInquiry').scrollIntoView()
        this.$refs.sendInquiry.sumitBoxState = true
        this.$refs.sendInquiry.saveObj = saveObj
      }
    },
    checkOneData (index) {
      if(this.nowShowType=='hotel'){
        this.hotelChangeIndex = index;
      }else if(this.nowShowType=='site'){
        this.siteChangeIndex = index
      }
    },
    tabCheckType (type) {
      if (this.nowShowType != 'hotel' && this.nowShowType != 'site') {
        this[type + 'Data'].adult = this[this.nowShowType + 'Data'].adult;
        this[type + 'Data'].children = this[this.nowShowType + 'Data'].children;
      }
      this.nowShowType = type;
    },
    changeDate(item){
      item.startDate = item.checkDate[0]
      item.endDate = item.checkDate[1]
    },
    delOneData(index,arr,type){
      arr.splice(index)
      if(type){
        if(this.nowShowType=='hotel'&&this.hotelChangeIndex==index){
          this.hotelChangeIndex--;
        }else if(this.nowShowType=='site'&&this.siteChangeIndex==index){
          this.siteChangeIndex--;
        }
      }
    },
    addOneData () {
      if (this.nowShowType == 'hotel') {
        var obj = JSON.parse(JSON.stringify(this.hotelData[this.hotelData.length - 1]));
        if (obj.checkDate.length > 0) {
          obj.checkDate[0] = obj.checkDate[1];
          obj.startDate = obj.checkDate[1]
          obj.checkDate[1] = this.dateFormatYMD(this.dateAddDay(obj.checkDate[1],1).getTime(),"-");
          obj.endDate =  obj.checkDate[1]
        }
        this.hotelData.push(obj);
        this.hotelChangeIndex++;
      } else if (this.nowShowType == 'site') {
        document.getElementById('siteProjectInquiry').scrollIntoView()
        var obj = JSON.parse(JSON.stringify(this.siteData[this.siteData.length - 1]));
        this.siteData.push(obj)
        this.siteChangeIndex++;
      }
    },
  },
  mounted(){
    var nowYear = parseInt(new Date().getFullYear());
    for (var i = 0; i < 2; i++) {
      this.yearOption.push(nowYear + i);
    }
    var obj={
      adult:null,
      children:null,
      planType:1,
      remarks:null,
    }
    this.$refs.inquiryTypeTab.navTabData.forEach(item=>{
      if(item.nameEn!='hotel'&&item.nameEn!='site'){
        obj.inquiryPlan = JSON.parse(JSON.stringify(this.inquiryPlanObj))
        this[item.nameEn + 'Data'] = JSON.parse(JSON.stringify(obj));
        this.$set(this[item.nameEn + 'Data'],item.propName,[JSON.parse(JSON.stringify(this[item.propName]))])       
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.productInquiry{
  position: relative;
  /deep/ .el-input__inner{
    height: 0.3rem;
  }
  width: 12rem;
  margin: 0 auto;
  .sd_hotel_mod{
    display: flex;
    justify-content: space-between;
    font-size: 0.12rem;
    .hotel_mod_left{
      width: 6.2rem;
      border-radius: 20px;
      box-shadow: 0px 0px 15px 0px #bbb;
      padding: 0.25rem;
      .infor_input{
        width: 100%;
        box-shadow: 0px 0px 15px 0px #bbb;
        border-radius: 20px;
        padding: 0.1rem 0.3rem 0.5rem 0.3rem;
        margin-top: 0.2rem;
        .date_city_li {
          font-size: 0.14rem;
          font-weight: bold;
          color: #e65019;
          span{
            margin-right: 0.1rem;
          }
        }
      }
      .mod_li{
        padding: 0.1rem;
        cursor: pointer;
        border-radius: 10px;
        /deep/.el-date-editor{
          width: 2.2rem;
          height: 0.3rem !important;
        }
        /deep/.el-range__close-icon{
          width: 0.01rem;
        }
        /deep/ .el-range-separator{
          width: 14% !important;
        }
        /deep/ .el-autocomplete{
          width: 1.25rem;
          height: 0.3rem !important;
          margin-left: 0.1rem;
        }
      }
      .mod_li:hover {
        background: #f5f6f7;
      }
      .checkedLi {
        background: #fcedbd;
      }
      .input_infor_show {
        width: 1.9rem;
        background: #e65019;
        border-radius: 20px;
        color: #fff;
        margin: -0.3rem auto 0 auto;
        font-size: 0.16rem;
        font-weight: bold;
        padding: 0.15rem 0.3rem;
      }
      .xuhao{
        display: inline-block;
        width: 0.26rem;
        height: 0.26rem;
        color: #fff;
        background: #ec784e;
        border-radius: 50%;
        text-align: center;
        line-height: 0.26rem;
      }
      .site_div_one{
        padding-left: 0.4rem;
        padding-top: 0.15rem;
        >b{
          font-size: 0.14rem;
        }
      }
      .site_div_two{
        padding-left: 0.1rem;
        margin-top: 0.1rem;
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        .el-icon-delete{
          display: inline-block;
          width: 0.3rem;
          height: 0.3rem;
          line-height: 0.25rem;
          border-radius: 50%;
          border: 1px solid #919191;
          text-align: center;
          margin-left: 1rem;
          color: #919191;
        }
      }
      .site_div_three{
        padding: 0.1rem 0rem 0.15rem 0.4rem;
      }
      .site_infor{
        width: 100%;
        box-shadow: 0px 0px 15px 0px #bbb;
        border-radius: 20px;
        padding: 0.2rem 0.3rem 0.6rem 0.3rem;
        margin-top: 0.2rem;
        font-size: 0.14rem;
      }
    }
    .hotel_mod_right{
      width: 5.5rem;
      ul{
        li{
          margin-bottom:0.25rem;
          display: flex;
          .hmr_left{
            width: 0.6rem;
            b{
              font-size: 0.3rem;
              color: #f50057;
              display: inline-block;
              width: 0.6rem;
              text-align: center;
            }
            p{
              height: 0.03rem;
              background: #f94a56;
              position: relative;
              i{
                height: 0.14rem;
                width: 0.14rem;
                background: #f94a56;
                border-radius: 100%;
                position: absolute;
                top: -5px;
              }
              span{
                color: #f94a56;
                font-size: 0.3rem;
                position: absolute;
                right: -0.1rem;
                top: -0.13rem;
              }
            }
          }
          .hmr_right{
            width: 4.8rem;
            margin-left: 0.15rem;
            background: #f5f6f7;
            border-radius: 0.2rem;
            padding: 0.15rem 0.18rem;
            p:first-of-type {
              font-size: 0.18rem;
              color: #f54402;
              font-weight: bold;
              margin-bottom: 0.1rem;
            }
          }
        }
      }
    }
  }
  .bus_outSide_box{
    width: 11.1rem;
    margin: 0 auto;
    .bus_mod_box{
      border-radius: 15px;
      padding: 0.25rem  0.25rem 0.6rem 0.25rem;
      box-shadow: 0px 0px 15px 0px #333;
      .car_type_box{
        background: #f7f7f7;
        border-radius: 5px;
        margin: 0.16rem 0;
        padding: 0.05rem 0.3rem 0.05rem 0.05rem;
        display: flex;
        font-size: 0.12rem;
        .needText{
          height: 0.4rem;
          display: flex;
          align-items: center;
          width: 0.85rem;
        }
        .special{
          width: 0.85rem;
          justify-content: flex-end;
          padding-right: 0.09rem;
          display: flex;
          align-items: center;
        }
        .andOr {
          background: #6680f4;
          color: #fff;
          display: inline-block;
          height: 0.3rem;
          width: 0.3rem;
          line-height: 0.3rem;
          text-align: center;
          border-radius: 50%;
          cursor: pointer;
          font-style: inherit;
        }
        .li{
          display: flex;
          margin-bottom: 0.1rem;
          align-items: center;
          >span{
            margin-right: 0.05rem;
          }
        }
        .el-icon-remove-outline {
          font-size: 0.32rem;
          margin-right: 0.05rem;
        }
        .selectSpan /deep/ .el-input__inner{
          padding-left: 0.1rem !important;
        }
        /deep/ .el-input__inner{
          padding-right: 0.1rem !important;
          padding-left: 0.35rem;
        }
        /deep/ .el-input__prefix{
          left: 4px;
        }
        /deep/ .el-input__suffix{
          right: 3px;
        }
        /deep/ .el-input__icon{
          width: 19px;
        }
        /deep/ .el-radio{
          margin-right: 0.1rem;
        }
        /deep/ .el-radio__label{
          padding-left: 0.05rem;
        }
        >b{
          display: inline-block;
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          background: #e17148;
          color: #fff;
          font-size: 0.18rem;
          text-align: center;
          line-height: 0.5rem;
          font-weight: normal;
          margin-right: 0.3rem;
        }
      }
    }
  }
}
</style>